<template>
    <div class="web_index">
    <div class="web_title">
      <div class="web_title_content">
        <img class="title_img" src="../../assets/png/nav_logo_title.png" >
        <div class="title_content">
            <div class="title" >
                <span style="cursor:pointer;margin-right: 50px;" @click="jump(5)">联系我们</span>
            </div>
            <div  class="title">
                <span style="cursor:pointer;margin-right: 50px;" @click="jump(4)">加入我们</span>
            </div>
            <div class="title">
                <span style="cursor:pointer;margin-right: 50px;" @click="jump(3)">商务合作</span>
            </div>
            <div  class="title">
                <span style="cursor:pointer;margin-right: 50px;" @click="jump(2)">关于我们</span>
            </div>
            <div  class="title">
                <span style="cursor:pointer;margin-right: 50px;" @click="jump(1)">首页</span>
            </div>
        </div>
      </div>
    </div>

    <div style="width: 100%;height: 100px"></div>
    <div class="web_content">
        <div class="web_content_inner" v-html="respData.content"></div>
    </div>

        <component v-bind:is="'BaseBottom'"></component>
  </div>
</template>

<script>
    import BaseBottom from './BaseBottom.vue'
    import router from '../../router'
export default {
    components: {BaseBottom: BaseBottom},
  name: 'Index',
  data () {
    return {
        pageId:'',
        jumpType:4,
        respData:{}
    }
  },
  methods: {
      jump(type){
          let that = this
          // that.jumpType = type
          if (type == 2){
              router.push({
                  path: 'area',
                  // query:{'jumpType':type}
              })
          } else if (type == 3){
              router.push({
                  path: 'cooperate',
                  // query:{'jumpType':type}
              })
          }  else if (type == 1){
              router.push({
                  path: '/',
                  // query:{'jumpType':type}
              })
          } else if (type == 5){
              router.push({
                  path: 'contact',
                  // query:{'jumpType':type}
              })
          }
      },

      load: function (){
          let that = this
          this.$http.get('/admin/adwebs/getAdWeb', {params: {id:this.pageId}})
              .then(function (res) {
                  that.respData = res.data.adWeb
//                  document.title=that.respData.title
              }).catch(function (err) {
              console.log('er getAd' + err)
          })
      },
  },
  mounted () {

      this.pageId = this.$route.query.id
//      alert(this.$route.query.id)
      this.load()
  },
    updated(){

    }
}
</script>


<style scoped="page">
    .web_index{
        width: 100%;
        background-color: #F0F4F5;
    }
    .web_title{
        width: 100%;
        height: 80px;
        background-color: #ffffff;
        position: fixed;
        top: 0;
        z-index: 1000;
    }
    .web_title_content{
        width: 1290px;
        height: 80px;
        margin: auto;
        position: relative;
    }
    .title_img{
        margin-left: 40px;
        margin-top: 18px;
    }
    .title_content{
        height: 80px;
        position: absolute;
        right:45px;
        top: 0;
    }
    .title{
        float: right;
        height: 80px;
        line-height: 80px;
        font-size: 18px;
    }
    .title_red{
        float: right;
        height: 70px;
        line-height: 80px;
        font-size: 18px;
        border-bottom: 2px solid #cd001b;
        color: #000000;
    }
  .web_content{
    width: 1210px;
    margin: auto;
    /*margin-top: 100px;*/
    margin-bottom: 60px;
    line-height: 16px;
    background-color: #FFFFFF;
      /*padding:20px 50px;*/
  ;
  }

  .web_content_inner{padding: 20px 50px;}




    .web_content_inner >>> p{margin: 0;font-size: 16px;line-height: 26px;font-family: initial !important;}
    .web_content_inner >>> span{margin: 0;font-size: 16px;line-height: 26px;font-family: initial !important;}


</style>



// WEBPACK FOOTER //
// src/components/web/Page.vue